import { Model } from "@mcleod/core";
import { AutogenLayoutStopQuickInfo } from "./autogen/AutogenLayoutStopQuickInfo";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class StopQuickInfo extends AutogenLayoutStopQuickInfo {

    /** This is an event handler for the afterExecution event of sourceStop. */
    sourceStopAfterExecution(event: DataSourceExecutionEvent) {
        if (event.data?.data) {
            Model.searchSingleRecord("lme/dispatch/stop", {"id": event.data.get("id"), "_field_list": {layoutName: this.layoutName}})
                .then((stop) => {
                    if (stop.data?.order_id !== null) {
                        this.labelId.link = "lme/dispatch/OrderTabView?mode=update&section=stops&key=" + stop.data.order_id;
                        this.labelId.visible = true;
                    }
                });
        }
    }
}
